<template>
    <th
        class="admin-th-sort"
        :class="{
            'is-active': isActive,
            'is-asc': isActive && order === 'asc',
            'is-desc': isActive && order === 'desc',
        }"
        role="columnheader"
        scope="col"
        :aria-sort="ariaSort"
        aria-keyshortcuts="Enter Space"
        tabindex="0"
        @click.prevent="onSort"
        @keydown.enter.prevent="onSort"
        @keydown.space.prevent="onSort"
    >
        <span class="admin-th-sort__inner">
            <span class="admin-th-sort__label"><slot></slot></span>
            <span class="admin-th-sort__icons" aria-hidden="true">
                <admin-icon name="chevron-up" class="admin-th-sort__up"></admin-icon>
                <admin-icon name="chevron-down" class="admin-th-sort__down"></admin-icon>
            </span>
        </span>
    </th>
</template>

<script>
export default {
    name: 'sortable-th',
    props: {
        field: {
            type: String,
            required: true,
        },
        sortBy: {
            type: String,
            default: '',
        },
        order: {
            type: String,
            default: 'asc',
        },
    },
    computed: {
        isActive() {
            return this.sortBy === this.field;
        },
        ariaSort() {
            if (!this.isActive) {
                return 'none';
            }
            return this.order === 'desc' ? 'descending' : 'ascending';
        },
    },
    methods: {
        onSort() {
            this.$emit('sort', this.field);
        },
    },
};
</script>
